export type CreateComponentDeploymentRequestsRequest = {
  processTyp: string;
  forceStgDplyFlg: boolean;
  dplyImplType: string;
  dplymntDtime: string;
  componentList: Component[];
};

type Component = {
  pjtId: string;
  tcktId: string;
};
